<template>
    <div class="list-group" style="padding-top: 30px">
        <div class="row">
            <div class="col-sm-6 col-md-4" v-for="survey in surveys_list">
                <div class="thumbnail">
                    <img src="https://via.placeholder.com/300">
                    <div class="caption">
                        <h3>{{survey[localize('title')]}}</h3>
                        <h4>50%</h4>
                        <p>
                            <router-link class="btn btn-primary" role="button"
                                         :to="{name:'account-survey-view', params:{id:1}}"> {{$t('surveys.fill_correct')}}
                            </router-link>


                            <a href="#" class="btn btn-info" role="button" data-toggle="modal">{{$t('surveys.read_more')}}</a>
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-4">
            </div>

            <div class="col-sm-6 col-md-4" v-for="survey in surveys_list">
                <div class="thumbnail">
                    <img src="https://via.placeholder.com/300">
                    <div class="caption">
                        <h3>{{$t('surveys.extended_survey')}}</h3>
                        <h4>50%</h4>
                        <p>
                            <router-link class="btn btn-primary" role="button"
                                         :to="{name:'account-survey-view', params:{id:1}}">{{$t('surveys.fill_correct')}}
                            </router-link>


                            <a href="#" class="btn btn-info" role="button" data-toggle="modal">{{$t('surveys.read_more')}}</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {FETCH_SURVEYS_LIST} from "../store/actions";
    import {mapGetters} from 'vuex';
    import translatorMixin from '../mixins/translatorMixin';

    export default {
        name: "MySurveys",
        mixins: [translatorMixin],
        computed: {
            ...mapGetters(['surveys_list']),
        },
        mounted() {
            this.$store.dispatch(FETCH_SURVEYS_LIST);
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/MySurveys.vue